import { Component, ComponentInterface, Element, h, Host, JSX, Listen, Prop } from '@stencil/core';
import { isKeyboardClickOnFocusedElement } from '../../utils/is-keyboard-click-on-focused-element';
import { SharedDirectionService } from '../../global/workbench-global';

export type CardVariant = 'white' | 'light-grey' | 'dark-grey';

/**
 * @slot - Contents placed within the element
 */
@Component({
  tag: 'wb-card',
  styleUrl: './card.scss',
  shadow: true,
})
export class CardComponent implements ComponentInterface {
  @Element()
  public el: HTMLWbCardElement;

  /** @internal reflects global rtl */
  @Prop({ reflect: true, mutable: true })
  public isRtl: boolean = false;

  /** color variant of the card */
  @Prop({ reflect: true })
  public variant: CardVariant = 'white';

  /** makes card appear interactive */
  @Prop({ reflect: true })
  public interactive: boolean = false;

  public connectedCallback(): void {
    this.updateDirection();
  }

  @Listen('wbdirchange', { target: 'document' })
  public updateDirection() {
    this.isRtl = SharedDirectionService.isRtl;
  }

  @Listen('keydown')
  public handleKeyDown(ev: KeyboardEvent): void {
    if (this.interactive && isKeyboardClickOnFocusedElement(this.el, ev)) {
      ev.preventDefault();
      this.el.click();
    }
  }

  public render(): JSX.Element {
    return (
      <Host class="wb-card" tabindex={this.interactive ? '0' : '-1'}>
        <slot />
        {this.interactive && <div class="indicator" />}
      </Host>
    );
  }
}
